import React from 'react';
import { TextArea } from './TextArea';
import { ObservableField, useForm } from '../../ObservableForm';
import { TextAreaFieldFragment } from './TextAreaField.generated';
import { FormatAndLinkify } from '@99designs/spa-common';
import { NinedownText } from '../../NinedownText';

export type Props = TextAreaFieldFragment;

export function Edit({ id, label, required, placeholder, subtext, tooltip }: Props) {
    const form = useForm();

    return (
        <ObservableField
            form={form}
            name={id}
            title={label}
            message={subtext ?? ''}
            tooltip={tooltip ? tooltip : undefined}
            required={required ?? false}
            render={() => <TextArea placeholder={placeholder ?? ''} fill {...form.attach(id)} />}
        />
    );
}

export function View({ textAreaValue: value }: Props) {
    return value ? (
        <NinedownText>
            <FormatAndLinkify rawHtml={value} />
        </NinedownText>
    ) : null;
}

export function HasValue({ textAreaValue }: Props): boolean {
    return textAreaValue !== '';
}

export function getValue({ textAreaValue }: Props) {
    return textAreaValue;
}
